import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import LandingPage from './pages/LandingPage';
import Offer1 from './pages/Offer1';
import Offer2 from './pages/Offer2';
import Offer3 from './pages/Offer3';
import Offer4 from './pages/Offer4';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import OfferA from './pages/OfferA';
import OfferB from './pages/OfferB';
import OfferC from './pages/OfferC';
import AdminPanel from './pages/AdminPanel';
import ThankYou from './pages/ThankYou';
import ResumeCart from './pages/ResumeCart';
import { Toaster } from 'sonner';

function App() {
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    // Get or create user ID
    let storedUserId = localStorage.getItem('ugandaInsiderUserId');
    if (!storedUserId) {
      storedUserId = 'user_' + Math.random().toString(36).substr(2, 9);
      localStorage.setItem('ugandaInsiderUserId', storedUserId);
    }
    setUserId(storedUserId);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage userId={userId} />} />
          <Route path="/offer-1" element={<Offer1 userId={userId} />} />
          <Route path="/offer-2" element={<Offer2 userId={userId} />} />
          <Route path="/offer-3" element={<Offer3 userId={userId} />} />
          <Route path="/offer-4" element={<Offer4 userId={userId} />} />
          <Route path="/cart" element={<Cart userId={userId} />} />
          <Route path="/checkout" element={<Checkout userId={userId} />} />
          <Route path="/offer-a" element={<OfferA userId={userId} />} />
          <Route path="/offer-b" element={<OfferB userId={userId} />} />
          <Route path="/offer-c" element={<OfferC userId={userId} />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/cart/resume" element={<ResumeCart userId={userId} />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;